import { render, staticRenderFns } from "./s3_index.vue?vue&type=template&id=271c5b70&scoped=true&"
import script from "./s3_index.vue?vue&type=script&lang=js&"
export * from "./s3_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c5b70",
  null
  
)

export default component.exports